export default function LogInClick(type:'register'|'login'|null):void{
  type = type || 'login';
  const url = 'http://172.168.168.104:30520/#/login?active='+type;
  if (!window.open(url)) { window.location.href = url }
}